var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChildParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 366,
    viewBox: "0 0 393 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.95 267.45C382.55 262.05 374.45 262.05 369.05 267.45C365 271.5 362.3 274.2 358.25 278.25L324.5 194.55C324.5 193.2 323.15 191.85 323.15 190.5L375.8 204C379.85 205.35 385.25 204 387.95 201.3C390.65 198.6 393.35 194.55 392 189.15L382.55 108.15C378.5 85.2 359.6 69 338 69C325.85 69 315.05 74.4 306.95 82.5L279.95 109.5H186.8L171.95 66.3C163.85 44.7 149 27.15 128.75 15C100.4 -3.90005 62.6 -3.90005 34.25 15L7.25 31.1999C1.85 32.5499 0.5 37.9499 0.5 43.3499L14 151.35C15.35 158.1 20.75 163.5 27.5 163.5H54.5C59.9 163.5 63.95 160.8 66.65 155.4L77.45 133.8C82.85 172.95 77.45 212.1 61.25 248.55L47.75 278.25C45.05 275.55 41 271.5 36.95 267.45C31.55 262.05 23.45 262.05 18.05 267.45C12.65 272.85 12.65 280.95 18.05 286.35C66.65 337.65 132.8 366 203 366C273.2 366 339.35 337.65 387.95 286.35C393.35 280.95 393.35 272.85 387.95 267.45ZM107.15 317.4C124.7 282.3 162.5 258 203 258C243.5 258 281.3 282.3 298.85 317.4C269.15 330.9 236.75 339 203 339C169.25 339 136.85 330.9 107.15 317.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildParty);
export default __webpack_public_path__ + "static/media/child_party.9af4fcf607075b6ec66012feede2502c.svg";
export { ForwardRef as ReactComponent };